"use client";

import TrackingEvent from "@/components/events/tracking-event";
import { getGtmIntegrationSourceProps } from "@/lib/tracking/gtm-integration-source";
import type { IntegrationSource } from "@/lib/checkout/integration-sources";

export const ErrorPageTrackingTypes = [
  "payment_cancelled",
  "payment_failed",
  "session_expired",
  "fulfilment_failed",
] as const;

export type ErrorPageTrackingType = (typeof ErrorPageTrackingTypes)[number];

/**
 * Fires for all journeys. Hotel funnel adds integration_source: HotelFunnel
 * when present; retail/partner errors omit that key.
 */
export const ErrorPageTrackingEvent = ({
  errorType,
  integrationSource = "none",
}: {
  errorType: ErrorPageTrackingType;
  integrationSource?: IntegrationSource;
}) => (
  <TrackingEvent
    eventName="error_page_view"
    eventProps={{
      error_type: errorType,
      ...getGtmIntegrationSourceProps(integrationSource),
    }}
  />
);
